/* eslint-disable react/display-name */

import { QueryClient, QueryClientProvider } from "react-query";
import Layout from "./src/components/Layout";
import { ThemeProvider } from "@wealthx/ui/theme";
import {
  TenantThemeProvider,
  useTenantTheme,
} from "./src/context/tenant-theme-context";

/**
 * * Wraps every page in a component
 */
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  window.analytics &&
    window.analytics.page(location.href, {
      path: location.pathname,
      url: location.href,
      referrer: prevLocation ? prevLocation.href : null,
    });
};

const TenantThemedApp = ({ children }) => {
  const { colors } = useTenantTheme();
  return (
    <ThemeProvider primary={colors.primary} secondary={colors.secondary}>
      {children}
    </ThemeProvider>
  );
};

export const wrapRootElement = ({ element }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <TenantThemeProvider>
        <TenantThemedApp>{element}</TenantThemedApp>
      </TenantThemeProvider>
    </QueryClientProvider>
  );
};
